import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import "slick-carousel/slick/slick.css";

import React, { useState, useEffect } from "react";
import { Routes, Route, BrowserRouter as Router } from 'react-router-dom';

import BackToTop from './components/parts/BackToTop';
import Header from "./components/sections/Header";
import Footer from "./components/sections/Footer";

import Home from "./components/pages/Home";
import Contact from "./components/pages/Contact";
import Services from "./components/pages/Services";
import About from "./components/pages/About";

import CookieConsent from "react-cookie-consent";

import TherapyYoga from "./components/pages/TherapyYoga";
import ThetaHealing from "./components/pages/ThetaHealing";
import ZvucnaMasaza from "./components/pages/ZvucnaMasaza";

import BlogList from './components/pages/BlogList';
import BlogSingle from './components/pages/BlogSingle';
import Cjenik from "./components/pages/Cjenik";

function App() {

  // 🟢 REVIEWS STATE (FIXED PLACE)
  const [reviews, setReviews] = useState([]);
  const [index, setIndex] = useState(0);

  // 🟢 FETCH REVIEWS FROM WORDPRESS
  useEffect(() => {
    fetch("https://zenplacepula.zenplacepula.com/wp-json/wp/v2/reviews")
      .then(res => res.json())
      .then(data => setReviews(data))
      .catch(err => console.log(err));
  }, []);

  // 🟢 AUTO CAROUSEL
  useEffect(() => {
    if (reviews.length === 0) return;

    const interval = setInterval(() => {
      setIndex(prev => (prev + 1) % reviews.length);
    }, 10000);

    return () => clearInterval(interval);
  }, [reviews]);

  return (
    <Router>
      <div className="App">

        <Header />

        {/* 🍪 COOKIE BANNER */}
        <CookieConsent
          location="bottom"
          buttonText="U redu"
          cookieName="zenplace_cookie_consent"
          style={{ background: "#0E5C63" }}
          buttonStyle={{ background: "#84D99C", color: "#000" }}
          expires={150}
        >
          Koristimo kolačiće kako bismo poboljšali korisničko iskustvo i funkcionalnost stranice.
        </CookieConsent>

        {/* 🌍 ROUTES */}
        <Routes>
          <Route index element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/TherapyYoga" element={<TherapyYoga />} />
          <Route path="/ThetaHealing" element={<ThetaHealing />} />
          <Route path="/ZvucnaMasaza" element={<ZvucnaMasaza />} />
          <Route path="/BlogList" element={<BlogList />} />
          <Route path="/blog/:id" element={<BlogSingle />} />
          <Route path="/Cjenik" element={<Cjenik />} />
        </Routes>

        {/* ⭐ REVIEWS FOOTER (WORDPRESS DRIVEN) */}
        {reviews.length > 0 && (
          <div className="reviews-footer text-center py-5">

            <div className="review-card">
              <p>
                "{reviews[index].content.rendered.replace(/<[^>]+>/g, '')}"
              </p>
              <h5>- {reviews[index].title.rendered}</h5>
            </div>

          </div>
        )}

        <BackToTop />
        <Footer />

      </div>
    </Router>
  );
}

export default App;